/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandPopularItemsEnabledRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandPopularItemsEnabledResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandPopularItemsEnabled = (request: SetBrandPopularItemsEnabledRequest, options?: CashRequestOptions) => post<SetBrandPopularItemsEnabledRequest, SetBrandPopularItemsEnabledResponse>("/2.0/cash/set-brand-popular-items-enabled", request, {...options, rejectOnError: true })